import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useAesContextualNav } from '../aes-nav';
import { StreamList } from './streams/StreamList';
import { StreamCreate } from './streams/StreamCreate';
import { StreamDetail } from './streams/StreamDetail';

/**
 * Self-hosted streams routes (the DRM packager pipeline over sig-control) under
 * the AES gateway service scope. Overview/usage/logs are now SHARED service-level
 * pages, so this console only owns the stream-management surface:
 *
 *   /services/aes/:serviceId/drm             → redirect to the merged service Overview
 *   /services/aes/:serviceId/drm/streams     → Sources & Streams catalog
 *   /services/aes/:serviceId/drm/streams/new → Add-source wizard (probe → confirm)
 *   /services/aes/:serviceId/drm/streams/:id → Stream detail (source→key→output)
 *
 * The contextual sidebar is the SAME unified AES menu as the gateway console
 * (useAesContextualNav), so navigating here keeps one stable menu.
 */
export function DrmConsole() {
  const { serviceId } = useParams<{ serviceId: string }>();
  const base = `/services/aes/${serviceId}/drm`;
  const root = `/services/aes/${serviceId}`;

  useAesContextualNav(serviceId);

  return (
    <Routes>
      {/* /drm and any stale /drm/{usage,audit,keys} deep links → merged Overview. */}
      <Route index element={<Navigate to={root} replace />} />
      <Route path="streams" element={<StreamList base={base} />} />
      <Route path="streams/new" element={<StreamCreate base={base} />} />
      <Route path="streams/:streamId/*" element={<StreamDetail base={base} />} />
      <Route path="*" element={<Navigate to={root} replace />} />
    </Routes>
  );
}

export default DrmConsole;
